export const WALK_STATS = "1";
export const TWO_MIN_WALK = "2";
export const SIX_MIN_WALK = "3";
export const TEN_METER_WALK = "4";
export const SQUATS = "5";
export const STEPS_IN_PLACE = "6";
